<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../../api.js';
    import UserStore from '../../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../../components/Header.svelte'; 
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 

    let isLoading = false;


    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
    })



</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">
            <h1 class="text-start">{$_('services.title')}</h1>            
            <div class="flex gap-2">
                <div class="border p-3 mb-3 flex-col w-[200px]" on:click={()=> push('/agents/products')}>
                    <div class="image me-3">
                        <i class="fa-brands fa-product-hunt"></i>
                    </div>
                    <div>
                        <div class="name">{$_('agents.products.name')}</div>
                        <div class="desc">{$_('agents.products.desc')}</div>
                    </div>
                </div>
                <div class="border p-3 mb-3 flex-col w-[200px]" on:click={()=>push('/agents/cart')}>
                    <div class="image me-3">
                        <i class="fa-solid fa-basket-shopping"></i>
                    </div>
                    <div>
                        <div class="name">{$_('agents.cart.name')}</div>
                        <div class="desc">{$_('agents.cart.desc')}</div>
                    </div>
                </div>
                <div class="border p-3 mb-3 flex-col w-[200px]" on:click={()=> push('/agents/orders')}>
                    <div class="image me-3">
                        <i class="fa-solid fa-list"></i>
                    </div>
                    <div>
                        <div class="name">{$_('agents.orders.name')}</div>
                        <div class="desc">{$_('agents.orders.desc')}</div>
                    </div>
                </div>
                
            </div>
        </div>
        
    </div>
</div>
<style>
    p {
        font-size:14px;
        font-weight: bold;
    }
    .desc {
        font-size:14px;
    }
    .border {
        border:1px solid #efefef;
    }
    .image i {
        font-size:20px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }
    .flex {
        display: flex;
        align-items: center;
    }
</style>
